import { render, staticRenderFns } from "./business-info-form.vue?vue&type=template&id=5c9bce2a"
import script from "./business-info-form.vue?vue&type=script&lang=js"
export * from "./business-info-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports